var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{ref:"vid",attrs:{"id":"remoteVideo","autoplay":"","playsinline":"","webkit-playsinline":""},domProps:{"muted":_vm.muted},on:{"canplay":_vm.handleCanPlay}})
}
var staticRenderFns = []

export { render, staticRenderFns }